module.exports = __webpack_public_path__ + "15a9c8937aafa0c28a51682d9b71c425.svg";